import { Address, CreateAddress, UpdateAddress } from "../../../address/types/models/Address";
import { CuttingState } from "./CuttingState.d";
import { ShipmentState } from "./ShipmentState.d";
import { ShipmentType } from "./ShipmentType.d";
import { UserType } from "./UserType.d";
import { CordwoodMeasurementType } from "./CordwoodMeasurementType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity ForestOwners


export interface ForestOwner {
    id: ID;

    
    name: string;

    
    description?: string;

    
    vatId?: string;

    
    iban?: string;

    
    bank?: string;

    
    scopeGroupId: ID;

    
    swift?: string;

    
    addressIdAddress?: Address;
    

    }




export interface CreateForestOwner {
    
    name: string;

    
    description?: string;

    
    vatId?: string;

    
    iban?: string;

    
    bank?: string;

    
    
    swift?: string;

    
    addressIdAddress?: CreateAddress;
    

    }


export interface UpdateForestOwner {
    
    name: string;

    
    description?: string;

    
    vatId?: string;

    
    iban?: string;

    
    bank?: string;

    
    
    swift?: string;

    
    addressIdAddress?: UpdateAddress;
    

    }

export interface PresentationForestOwnerRequest {
    list: ListRequest,
    filter: {
        name: string,
        nameOr: boolean,
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryForestOwner {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: ForestOwner): PrimaryForestOwner | undefined {
        return entity ? new PrimaryForestOwner(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryForestOwner {
        return new PrimaryForestOwner(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryForestOwner {
        let vals = path?.split('/');
        return new PrimaryForestOwner(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryForestOwner[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: ForestOwner): string {
    let fields = entity ? [
    entity.name,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityForestOwner {
    id: PrimaryForestOwner;
    data: UpdateForestOwner;


    constructor(id: PrimaryForestOwner, data: UpdateForestOwner) {
        this.id = id;
        this.data = data;
    }
}
